import { Charts } from './Charts';
import VaccinationChartsDataProvider from './contexts/VaccinationChartsDataContext';

const VaccinationWrapper = () => {
    return (
        <VaccinationChartsDataProvider>
            <Charts />
        </VaccinationChartsDataProvider>
    );
};

export default VaccinationWrapper;
